import React from "react";
import { useNavigate } from 'react-router-dom';

function Home()
{
  const history = useNavigate();
  return <h1> Welcome to the Home Page!</h1>;
}

export default Home;
